import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { ProductsComponent } from './components/products/products.component';

const routes: Routes = [
    {path:'home', component: HomeComponent},
    {path:'products', component: ProductsComponent},
    { path: '', redirectTo: '/home', pathMatch: 'full' }
]

@NgModule({
    imports: [
    RouterModule.forRoot(routes,{useHash: true }) 
    ],
    exports: [ RouterModule ]
  })
export class AppRoutingModule { }


// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts